import { Space } from "antd";
import React, { Suspense, useEffect, useRef, useState } from "react";
import { handleSubmitShortcut } from "../../../pages/utils/commonUtils";
import HButton from "../../custom/input/button/Button";

// Lazy load ReactQuill
const ReactQuill = React.lazy(() => import("react-quill"));

const MAX_LENGTH = 500;
const modules = {
  toolbar: "#custom-toolbar",
};

const NotesEditor = ({ onSave, onCancel, isEditing = false, currentValue = "", setCurrentValue, entityId, editorRef = null }) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleSetCurrentValue = (value) => {
    setCurrentValue(entityId, value);
  };

  const handleSave = () => {
    handleSetCurrentValue(currentValue);
    if (onSave) onSave(currentValue);
  };

  const handleCancel = () => {
    handleSetCurrentValue(currentValue); // Reset to original value
    if (onCancel) onCancel();
  };

  // Load CSS when component mounts
  useEffect(() => {
    import("react-quill/dist/quill.snow.css");
  }, []);

  const handleChange = (content, delta, source, editor) => {
    const plainText = editor.getText(); // includes a trailing newline
    if (plainText.trim().length > MAX_LENGTH) {
      editorRef.current.getEditor().deleteText(MAX_LENGTH, editor.getLength());

      if (!errorMessage) {
        setErrorMessage("Please keep your note within 500 characters.");
      }
      return;
    }

    if (errorMessage && plainText.trim().length < MAX_LENGTH) {
      setErrorMessage("");
    }
    handleSetCurrentValue(content);
  };

  return (
    <Space direction="vertical" className="w-100">
      <div className="hs-ql-editor-container py-2">
        <Suspense
          fallback={
            <div className="d-flex justify-content-center align-items-center h-100 my-5">
              <div className="actionIconsSprite search-loading"></div>
            </div>
          }
        >
          <ReactQuill
            modules={modules}
            onKeyDown={(e) => handleSubmitShortcut(e, handleSave)}
            ref={editorRef}
            value={currentValue}
            onChange={handleChange}
            preserveWhitespace
            placeholder={isEditing ? "Edit note" : "Add Note"}
            className="hs-ql-editor"
            style={{ minHeight: 50, maxHeight: 300, overflowY: "auto" }} // ~5 rows height
          />
        </Suspense>
        <div className="d-flex justify-content-between align-items-center">
          <span className="hs-fs-12 hs-fw-500 px-2">{`${Math.min(
            currentValue.replace(/<[^>]+>/g, "").length,
            MAX_LENGTH
          )} / ${MAX_LENGTH}`}</span>
          {errorMessage && <span className="hs-fs-12 hs-fw-500 text-danger">{errorMessage}</span>}
        </div>
      </div>

      <div className="d-flex flex-row-reverse gap-2">
        <>
          <HButton onClick={handleSave} size="sm">
            <div className="hs-fs-12 hs-fw-500">{isEditing ? "Update Note" : "Add Note"}</div>
          </HButton>
          {isEditing && onCancel && (
            <HButton onClick={handleCancel} size="sm" variant="outline">
              <div className="hs-fs-12 hs-fw-500">Cancel</div>
            </HButton>
          )}
        </>
      </div>
    </Space>
  );
};

export default NotesEditor;
